import { Loader2 } from 'lucide-react';

export const PageSpinner = () => (
  <div className="flex items-center justify-center w-full py-20">
    <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
  </div>
);
